import React from 'react';

export const ConsultationRatingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z" fill="#858585"/>
    < path fill-rule="evenodd" clip-rule="evenodd" d="M5.55648 15.5276L4 18.9999L7.55648 17.2645H18.2231C18.7754 17.2645 19.2231 16.8168 19.2231 16.2645V7.42236C19.2231 5.87008 18.7754 5.42236 18.2231 5.42236H12.7231H6.55648C6.00419 5.42236 5.55648 5.87008 5.55648 7.42236V15.5276ZM14 9.49986L12.7231 6.42236L11.5 9.39605H7.72314L10.7231 11.4224L9.72314 14.9224L12.7231 12.9224L15.7231 14.9224L14.7231 11.4224L17.7231 9.39605L14 9.49986Z" fill="white"/>
  </svg>
)

